// extracted by mini-css-extract-plugin
export default {"container":"deportes_container__HTRA3","deportes":"deportes_deportes__NcMJT"};